"use client";

import { useEffect, useState, useTransition } from "react";
import type { FormEvent } from "react";
import { useRouter } from "next/navigation";
import { btn } from "./ui";
import {
    Search,
} from "lucide-react";

type Props = {
    /** مسیر صفحه‌ی نتایج: /forum یا /forum/cat/slug */
    basePath: string;
    tab: "q" | "ads";
    defaultValue?: string;
};

/**
 * جستجوی انجمن بدون رفرش صفحه:
 * با اینتر، آدرس به‌صورت soft navigation عوض می‌شود؛ تا رسیدن نتایج دایره‌ی لودینگ
 * روی دکمه و (بعد از رسیدن پاسخ) داخل ناحیه‌ی نتایج دیده می‌شود.
 */
export default function ForumSearch({ basePath, tab, defaultValue = "" }: Props) {
    const router = useRouter();
    const [value, setValue] = useState(defaultValue);
    const [pending, start] = useTransition();

    useEffect(() => setValue(defaultValue), [defaultValue]);

    const submit = (e: FormEvent) => {
        e.preventDefault();
        const q = value.trim();
        const sp = new URLSearchParams();
        if (tab === "ads") sp.set("tab", "ads");
        if (q) sp.set("q", q);
        const qs = sp.toString();
        start(() => router.push(qs ? `${basePath}?${qs}` : basePath, { scroll: false }));
    };

    return (
        <form
            onSubmit={submit}
            role="search"
            className="flex w-full items-center gap-2.5 rounded-xl border border-white/15 bg-white/10 py-1.5 pl-2 pr-3.5 text-white focus-within:bg-white/90 focus-within:text-gray-900 md:max-w-[620px]"
        >
            <input
                type="text"
                name="q"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="جستجو در پرسش‌ها، مدل تجهیزات یا آگهی‌ها"
                aria-label="جستجو در انجمن"
                className="h-10 min-w-0 flex-1 border-0 bg-transparent text-sm text-inherit outline-none dark:text-gray-700 dark:focus:text-gray-100 placeholder:text-white/60 focus:placeholder:text-gray-800"
            />
            <button type="submit" disabled={pending} className={`${btn("amber", true)} min-w-[78px] justify-center`}>
                {pending ? (
                    <span
                        className="h-4 w-4 animate-spin rounded-full border-2 border-[#14202B]/30 border-t-[#14202B]"
                        role="status"
                        aria-label="در حال جستجو"
                    />
                ) : (
                    <Search className="h-4 w-4 " />
                )}
            </button>
        </form>
    );
}
